import {environment} from "../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const CustomerApiResources = {
  list:  createUrl('customers'),
  copy:  createUrl('customers/copy'),
  search:  createUrl('customers/search'),
  create:  createUrl('customers/create'),
  detail:  createUrl('customers'),
  update:  createUrl('customers'),
  delete:  createUrl('customers'),
  deleteMultiple:  createUrl('customers/delete/multiple'),
  deleteAvailability:  createUrl('customers/delete/availability'),
  onhold:  createUrl('customers/onhold'),
  changeStatus:  createUrl('customers/change-status'),
  import:  createUrl('customers/import'),
  downloadSample:  createUrl('customers/import/sample'),
  uploadImport:  createUrl('customers/import/upload'),
  validateImport:  createUrl('customers/import/validate'),
  executeImport:  createUrl('customers/import/execute'),
  importHistory:  createUrl('import-history'),
  // Customer default PDF template per module (mapping only - template listing
  // and preview come from the existing template/* endpoints).
  customerPdfTemplate:  createUrl('customers/pdf-template'),
  // Customer Site Information
  customerSites:  createUrl('customers'),
  createCustomerSite:  createUrl('customers/sites'),
  // Jobsite Requirements, Accesses, and Parking (shared with bids)
  jobsiteRequirements:  createUrl('jobsite/requirements'),
  jobsiteAccesses:  createUrl('jobsites/accesses'),
  createJobsiteAccess:  createUrl('jobsites/accesses'),
  jobsiteParking:  createUrl('jobsites/parking'),
  createJobsiteParking:  createUrl('jobsites/parking'),
};
